import { createHmac } from 'crypto'
import {
  ProductClicked,
  ProductViewed
} from '@/types/tracking'

const getSha = (payload: Record<string, unknown>, key = '') => {
  return createHmac('sha1', key).update(JSON.stringify(payload)).digest('hex')
}

/**
 * Recursively traverses an object and lowercases all of its values
 * @param payload The object that needs its values lowercased
 * @param keysToSkip A collection of keys where the logic doesn't apply
 */
const lowerCaseValues = (payload: unknown, keysToSkip: string[] = []) => {
  if (!payload) {
    return
  }
  return Object.entries(payload).reduce((updated, [key, value]) => {
    if (keysToSkip.includes(key)) {
      updated[key] = value
      return updated
    }

    const isString = typeof value === 'string'
    const isObject = typeof value === 'object'
    const isArray = Array.isArray(value)

    if (isArray) {
      updated[key] = value.map(val => lowerCaseValues(val, keysToSkip))
      return updated
    }

    if (isObject) {
      updated[key] = lowerCaseValues(value, keysToSkip)
      return updated
    }

    updated[key] = isString ? value.toLowerCase() : value

    return updated
  }, {})
}

const buildProductClickedPayload = (
  brand: string,
  category: string,
  location: string,
  variant: string
) => {
  return {
    listId: '',
    product: {
      brand,
      category,
      location,
      position: 0,
      price: 0,
      productId: '',
      variant
    }
  } as ProductClicked
}

const buildProductViewedPayload = (
    brand: string,
    category: string,
    location: string,
    text: string,
    variant: string
) => {
  return {
    listId: '',
    product: {
      brand,
      category,
      location,
      position: 0,
      price: 0,
      productId: '',
      text,
      variant
    }
  } as ProductViewed
}

export default {
  getSha,
  lowerCaseValues,
  buildProductClickedPayload,
  buildProductViewedPayload
}
